import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import orgConfig from 'org/configs/org.config';
import { selectEmailPopup } from 'core/selectors/user';
import { useSubscribeMember } from 'core/modules/Forms/hooks/useSubscribeMember';

import { triggerStickyFooterEmailIsViewed } from '../actions';

export function StickyFooterEmail({ config }) {
  const { earnType } = orgConfig;
  const [isUserOptedOutFromEmail, setIsUserOptedOutFromEmail] = useState(false);
  const dispatch = useDispatch();

  const {
    stickyFooterEmail: {
      emailImage, emailCTA, emailCongratualationsImage, emailCongratualationsCTA,
      subscribeOnEmailsOptions, subscribeOnFavoritesOptions,
    },
  } = config;

  const emailPopup = useSelector(selectEmailPopup);

  useEffect(() => {
    dispatch(triggerStickyFooterEmailIsViewed(emailPopup.emailGlobalOptOut === '1'));
  }, []);

  useEffect(() => {
    setIsUserOptedOutFromEmail(emailPopup.emailGlobalOptOut === '1');
  }, []);

  const subscribeMemberOnEmailAlerts = useSubscribeMember({
    callback: () => {
      setIsUserOptedOutFromEmail(false);
    },
    ...subscribeOnEmailsOptions,
  });
  const subscribeMemberOnFavoritesAlerts = useSubscribeMember(subscribeOnFavoritesOptions);

  const handleEmailSubscription = () => {
    subscribeMemberOnEmailAlerts();
    subscribeMemberOnFavoritesAlerts();
  };

  if (isUserOptedOutFromEmail) {
    return (
      <>
        <div className="mn_imageWrap">
          <img className="mn_image" src={emailImage} alt="" />
        </div>
        <div className="mn_info">
          <h3>Be the first to get the best deals and extra {earnType} offers<span className="mn_dot">.</span></h3>
        </div>
        <div className="mn_buttonWrap">
          <button onClick={handleEmailSubscription} className="mn_button">{emailCTA}</button>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="mn_imageWrap mn_congrats">
        <img className="mn_image" src={emailCongratualationsImage} alt="" />
      </div>
      <div className="mn_info">
        <h3>Congratulations! You'll see the best deals in your inbox soon.</h3>
      </div>
      <div className="mn_buttonWrap">
        <button className="mn_button" disabled>{emailCongratualationsCTA}</button>
      </div>
    </>
  );
}

export default StickyFooterEmail;
